module.exports = __webpack_public_path__ + "static/media/1.69499bd7.jpg";